import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { setCountDownTime } from '../../utils';

const ExpirationDate = ({ expireDay }) => {
     const newExpireDay = dayjs(expireDay);

     const [daysToExpiration, setDaysToExpiration] = useState(() => {
          return setCountDownTime(newExpireDay);
     });

     useEffect(() => {
          const expireDayInterval = setInterval(() => {
               const newDayToExpiration = setCountDownTime(newExpireDay);
               setDaysToExpiration(newDayToExpiration);
          }, 10000);

          return () => {
               clearInterval(expireDayInterval);
          };
     }, [newExpireDay]); // eslint-disable-line react-hooks/exhaustive-deps

     if (!expireDay || !daysToExpiration) {
          return null;
     }

     return <span className="course-expire-day">Your Access Expires in {daysToExpiration}</span>;
};

export default ExpirationDate;
